// extracted by mini-css-extract-plugin
module.exports = {"modal_button":"DefaultLanguageHelp_modal_button__ZCZd0","help_component":"DefaultLanguageHelp_help_component__33O44"};